module.exports = __webpack_public_path__ + "static/img/img-coupon-list02.22d4020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-coupon-list02.png
// module id = 4qHs
// module chunks = 1